import React, { Component } from 'react';
import DataSource from 'devextreme/data/data_source';
import DefaultGrid from '../../components/DefaultGrid';
import CrudForm from '../../template/CrudForm';
import Form, { SimpleItem, GroupItem, TabbedItem, Tab, BlankItem } from 'devextreme-react/form';
import { orderFieldsTransportLogisticRoute } from '../../utils/DefaultData';
import { TextArea } from 'devextreme-react';
import DataGrid, { RemoteOperations, Editing, Paging, Pager, Column } from 'devextreme-react/data-grid';
import { Popup } from 'devextreme-react/popup';
import ArrayStore from 'devextreme/data/array_store';
import API, {
	logisticRouteDataSource,
	vehicleDataSource,
	driverDataSource,
	logisticRouteStatusDataSource,
} from '../../services/AplicationService';
import {
	showSuccessMessage,
	showConfirmationMessage,
	handleError,
	formatNumberDecimalPlaces,
} from '../../utils/Utility';
import * as messages from '../../utils/Messages';

const masterProps = {
	title: 'Lançar Nota de Carregamento',
	subtitle: 'Gerencie as notas de carregamento',
};
const initialState = {
	transportLogisticRoute: {
		id: null,
		logisticRouteId: null,
		driverId: null,
		vehicleId: null,
		transportedOn: null,
		moreInformation: '',
		weight: null,
		totalWeight: null,
		vehicleWeight: null,
		status: '',
		statusId: null,
		fiscalDocumentDate: null,
		fiscalDocumentNumber: '',
		fiscalDocumentBarCode: '',
		isManual: true,
		historic: null,
	},
	changeStatusTransportLogisticRoute: {
		transportLogisticRoute: null,
		statusId: null,
		registerDate: null,
		description: null,
		weight: null,
		totalWeight: null,
		vehicleWeight: null,
		fiscalDocumentBarCode: '',
		fiscalDocumentNumber: '',
		fiscalDocumentDate: null,
	},
	popupChangeStatusTransportLogisticRoute: {
		show: false,
		actionText: '',
	},
	term: '',
	driverId: null,
	logisticRouteId: null,
	vehicleId: null,
	statusId: null,
	fiscalDocumentNumber: null,
	startDate: null,
	endDate: null,
	orderField: 4,
};

export default class TransportLogisticRoute extends Component {
	state = { ...initialState };
	transportLogisticRoute = {
		id: null,
		logisticRouteId: null,
		driverId: null,
		vehicleId: null,
		transportedOn: null,
		moreInformation: '',
		status: '',
		statusId: null,
		weight: null,
		totalWeight: null,
		vehicleWeight: null,

		fiscalDocumentDate: null,
		fiscalDocumentNumber: '',
		fiscalDocumentBarCode: '',
		isManual: true,
		historic: null,
	};
	changeStatusTransportLogisticRoute = {
		transportLogisticRoute: null,
		statusId: null,
		registerDate: null,
		moreInformation: null,
		weight: null,
		totalWeight: null,
		vehicleWeight: null,
		fiscalDocumentBarCode: '',
		fiscalDocumentNumber: '',
		fiscalDocumentDate: null,
	};

	constructor(props) {
		super(props);
		this.loadListTransportLogisticRoutes = this.loadListTransportLogisticRoutes.bind(this);
		this.getTransportLogisticRoute = this.getTransportLogisticRoute.bind(this);
		this.onClickSearch = this.onClickSearch.bind(this);
		this.onClickNew = this.onClickNew.bind(this);
		this.onClickSave = this.onClickSave.bind(this);
		this.setStateDataToInitial = this.setStateDataToInitial.bind(this);
		this.saveChangeStatusTransportLogisticRoute = this.saveChangeStatusTransportLogisticRoute.bind(this);
		this.showPopupChangeStatusLoadingTransport = this.showPopupChangeStatusLoadingTransport.bind(this);
		this.saveTransportLogisticRoute = this.saveTransportLogisticRoute.bind(this);
		this.getTransportLogisticRouteForEdit = this.getTransportLogisticRouteForEdit.bind(this);
		this.onClickSaveChangeStatus = this.onClickSaveChangeStatus.bind(this);
		this.onClickExport = this.onClickExport.bind(this);
		this.calculateWeight = this.calculateWeight.bind(this);
		this.dataGrid = React.createRef();
		this.crudForm = React.createRef();

		this.historicDataGrid = React.createRef();
		this.form = React.createRef();
		this.fieldOrder = new ArrayStore({
			data: orderFieldsTransportLogisticRoute,
			key: 'Id',
		});
	}
	componentDidMount() {
		if (this.props.location.state) {
			this.setState({ ...this.state, statusId: this.props.location.state.statusId });
		}
	}
	showPopupChangeStatusLoadingTransport = function (key, changeToStatusId, actionText = '') {
		this.crudForm.current.showLoadingPanel(true);
		let resultData = this.getTransportLogisticRoute(key);
		resultData.then(result => {
			// console.log(result);
			if (result) {
				API.get('transportLogisticRouteStatus/' + changeToStatusId)
					.then(response => {
						// console.log(response.data);
						this.setState({
							...this.state,
							popupChangeStatusTransportLogisticRoute: { show: true, actionText: actionText },
							changeStatusTransportLogisticRoute: {
								transportLogisticRoute: result,
								registerDate: new Date(),
								statusId: changeToStatusId,
								description: response.data.description,
								fiscalDocumentBarCode: result.fiscalDocumentBarCode,
								fiscalDocumentNumber: result.fiscalDocumentNumber,
								fiscalDocumentDate: result.fiscalDocumentDate,
							},
						});
						this.crudForm.current.showLoadingPanel(false);
					})
					.catch(error => {
						handleError(error, messages.errorGetData);
						this.crudForm.current.showLoadingPanel(false);
					});
			} else {
				this.crudForm.current.showLoadingPanel(false);
			}
		});
	};

	getTransportLogisticRouteForEdit(key) {
		this.crudForm.current.showLoadingPanel(true);
		let resultData = this.getTransportLogisticRoute(key);
		resultData.then(result => {
			if (result) {
				this.transportLogisticRoute = result;
				this.setState({ ...this.state, transportLogisticRoute: this.transportLogisticRoute });
				this.crudForm.current.setActiveTabIndex(1);
			}
			this.crudForm.current.showLoadingPanel(false);
		});
	}
	async getTransportLogisticRoute(key) {
		return API.get('transportLogisticRoutes/' + key)
			.then(response => {
				return response.data;
			})
			.catch(error => {
				handleError(error, messages.errorGetData);
			});
	}
	saveChangeStatusTransportLogisticRoute() {
		this.crudForm.current.showLoadingPanel(true);
		let changeStatusTransportLogisticRoute = { ...this.state.changeStatusTransportLogisticRoute };
		if (changeStatusTransportLogisticRoute.transportLogisticRoute.id !== null) {
			API.post('transportLogisticRoutes/ChangeStatusTransportLogisticRoute', changeStatusTransportLogisticRoute)
				.then(response => {
					showSuccessMessage('Status da ordem de carregamento alterado com sucesso!');
					this.setStateDataToInitial();
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorInsertData);
					this.dataGrid.current.reloadData();
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		}
	}
	saveTransportLogisticRoute() {
		this.crudForm.current.showLoadingPanel(true);
		let transportLogisticRoute = { ...this.transportLogisticRoute };
		if (transportLogisticRoute.id === null) {
			API.post('transportLogisticRoutes/', transportLogisticRoute)
				.then(response => {
					showSuccessMessage(messages.successInsertData);
					transportLogisticRoute = response.data;
					this.transportLogisticRoute = transportLogisticRoute;
					this.setState({ transportLogisticRoute: this.transportLogisticRoute });
					// console.log(this.transportLogisticRoute);
					//this.setStateDataToInitial();
					showConfirmationMessage('Deseja iniciar o carregamento dessa ordem?', e =>
						this.showPopupChangeStatusLoadingTransport(
							this.transportLogisticRoute.id,
							2,
							'Iniciar Carregamento'
						)
					);

					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorInsertData);
					this.dataGrid.current.reloadData();
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		} else {
			API.put('transportLogisticRoutes/' + transportLogisticRoute.id, transportLogisticRoute)
				.then(response => {
					showSuccessMessage(messages.successUpdateData);
					this.transportLogisticRoute = transportLogisticRoute;
					this.setState({ transportLogisticRoute: this.transportLogisticRoute });
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorUpdateData);
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		}
	}
	loadListTransportLogisticRoutes(page, pageSize) {
		let term = this.state.term;
		let logisticRoute = this.state.logisticRouteId;
		let driver = this.state.driverId;
		let vehicle = this.state.vehicleId;
		let status = this.state.statusId;
		let fiscalDocumentNumber = this.state.fiscalDocumentNumber;
		let startDate = this.state.startDate;
		let endDate = this.state.endDate;
		let orderField = this.state.orderField;

		if(orderField===null || orderField===undefined || orderField==='') {
			orderField = 4; // Default order field
		}

		return API.get('/transportLogisticRoutes', {
			params: {
				page: page,
				pageSize: pageSize,
				term: term,
				logisticRouteId: logisticRoute,
				driverId: driver,
				vehicleId: vehicle,
				statusId: status,
				fiscalDocumentNumber: fiscalDocumentNumber,
				startDate: startDate,
				endDate: endDate,
				orderField: orderField,
			},
		})
			.then(response => {
				let result = {
					data: response.data.transportLogisticRoutes,
					totalCount: response.data.totalRegisters,
				};
				return result;
			})
			.catch(error => {
				handleError(error, messages.errorListData);
			});
	}
	renderGrid() {
		return (
			<React.Fragment>
				<DefaultGrid
					ref={this.dataGrid}
					pageSize={50}
					keyField={'id'}
					showBorders={true}
					fncGetData={this.getTransportLogisticRouteForEdit}
					fncListData={this.loadListTransportLogisticRoutes}
					defaultColumns={[
						{ dataField: 'id', caption: 'Nº', width: '5%' },
						{
							dataField: 'transportedOn',
							dataType: 'date',
							format: 'dd/MM/yyyy HH:mm',
							caption: 'Data',
							width: '8%',
						},
						{ dataField: 'status', caption: 'Status', width: '10%' },
						{ dataField: 'sender', caption: 'Remetente' },
						{ dataField: 'recipient', caption: 'Destinatário' },
						{ dataField: 'shippingCompany', caption: 'Transportadora' },
						{ dataField: 'driver', caption: 'Motorista' },
						{ dataField: 'vehicle', caption: 'Veículo', width: '8%' },
						{ dataField: 'fiscalDocumentNumber', caption: 'Nota Fiscal', width: '7%' },
						{
							dataField: 'weight',
							caption: 'Peso',
							width: '7%',
							calculateCellValue: function (data) {
								var formatedValue = formatNumberDecimalPlaces(data.weight, 0);
								if (formatedValue) return formatedValue + ' Kg';
								else return '';
							},
						},
					]}
					buttons={[
						{
							name: 'edit',
							hint: 'delete',
							icon: 'fa fa-edit',
							visible: true,
						},
						{
							hint: 'Iniciar Carregamento',
							icon: 'fa fa-truck-loading',
							visible: function (e) {
								if (e.row.data.statusId === 1) return true;
							},
							onClick: e =>
								this.showPopupChangeStatusLoadingTransport(e.row.data.id, 2, 'Iniciar Carregamento'),
						},

						{
							hint: 'Finalizar Carregamento',
							icon: 'fa fa-truck',
							visible: function (e) {
								if (e.row.data.statusId === 2) return true;
							},
							onClick: e =>
								this.showPopupChangeStatusLoadingTransport(e.row.data.id, 3, 'Finalizar Carregamento'),
						},
						{
							hint: 'Faturar',
							icon: 'fa fa-dollar-sign',
							visible: function (e) {
								if (e.row.data.statusId === 3) return true;
							},
							onClick: e =>
								this.showPopupChangeStatusLoadingTransport(e.row.data.id, 5, 'Faturar Carregamento'),
						},
						{
							hint: 'Finalizar Transporte',
							icon: 'fa fa-check',
							visible: function (e) {
								if (e.row.data.statusId === 3) return true;
								// return !e.row.isEditing && !isChief(e.row.data.Position);
							},
							onClick: e =>
								this.showPopupChangeStatusLoadingTransport(e.row.data.id, 4, 'Finalizar Transporte'),
						},
					]}
				/>
			</React.Fragment>
		);
	}
	setStateDataToInitial() {
		this.transportLogisticRoute = { ...initialState.transportLogisticRoute };
		this.changeStatusTransportLogisticRoute = { ...initialState.changeStatusTransportLogisticRoute };
		this.setState({
			...this.state,
			transportLogisticRoute: this.transportLogisticRoute,
			changeStatusTransportLogisticRoute: this.changeStatusTransportLogisticRoute,
			popupChangeStatusTransportLogisticRoute: { show: false, actionText: '' },
		});
	}
	onClickSearch = function (e) {
		this.dataGrid.current.reloadData();
	};
	onClickExport = function (e) {
		const FileDownload = require('js-file-download');
		this.crudForm.current.showLoadingPanel(true);
		let term = this.state.term;
		let logisticRoute = this.state.logisticRouteId;
		let driver = this.state.driverId;
		let vehicle = this.state.vehicleId;
		let status = this.state.statusId;
		let fiscalDocumentNumber = this.state.fiscalDocumentNumber;
		let startDate = this.state.startDate;
		let endDate = this.state.endDate;
		let orderField = this.state.orderField;
		return API.get('/transportLogisticRoutes/generatereport', {
			params: {
				page: null,
				pageSize: null,
				term: term,
				logisticRouteId: logisticRoute,
				driverId: driver,
				vehicleId: vehicle,
				statusId: status,
				fiscalDocumentNumber: fiscalDocumentNumber,
				startDate: startDate,
				endDate: endDate,
				orderField: orderField,
			},
			responseType: 'blob',
		})
			.then(response => {
				FileDownload(response.data, 'relatorio_notas_carregamento.xlsx');
				// var blob = new Blob([response.data], {
				// 	type: 'application/xlsx',
				// });
				// var url = window.URL.createObjectURL(blob);
				// window.open(url);
			})
			.catch(error => {
				console.log(error);
				handleError(error, messages.errorListData);
			})
			.then(() => {
				this.crudForm.current.showLoadingPanel(false);
			});
	};
	onClickSave = function () {
		// if (
		// 	this.transportLogisticRoute.fiscalDocumentNumber !== null &&
		// 	this.transportLogisticRoute.statusId !== 5 &&
		// 	this.transportLogisticRoute.fiscalDocumentNumber !== ''
		// )
		// 	showConfirmationMessage(
		// 		'Ao preencher o número da nota fiscal a ordem mudará o status para faturada. Deseja continuar?',
		// 		this.saveTransportLogisticRoute
		// 	);
		// else {
		this.saveTransportLogisticRoute();
		// }
	};
	onClickSaveChangeStatus = function () {
		this.saveChangeStatusTransportLogisticRoute();
	};
	onClickNew = function () {
		showConfirmationMessage(messages.questionNewOperation, this.setStateDataToInitial);
	};
	calculateWeight = function () {
		if (this.state.changeStatusTransportLogisticRoute.totalWeight !== null && this.state.changeStatusTransportLogisticRoute.vehicleWeight !== null) {
			if (this.state.changeStatusTransportLogisticRoute.totalWeight > 0 && this.state.changeStatusTransportLogisticRoute.vehicleWeight > 0) {
				let weight = this.state.changeStatusTransportLogisticRoute.totalWeight - this.state.changeStatusTransportLogisticRoute.vehicleWeight;
				this.setState({
					...this.state,
					changeStatusTransportLogisticRoute: { ...this.state.changeStatusTransportLogisticRoute, weight }
				});
			}
		}
	}
	renderFilter() {
		return (
			<Form
				formData={this.state}
				colCount={1}
				alignItemLabels={true}
				alignItemLabelsInAllGroups={true}
				showColonAfterLabel={false}
				labelLocation={'left'}
			>
				<GroupItem colCount={5}>
					<SimpleItem
						colSpan={1}
						dataField={'fiscalDocumentNumber'}
						cssClass="uppercase"
						label={{ text: 'Nota Fiscal', showColon: false }}
					/>
					<SimpleItem
						colSpan={2}
						dataField={'statusId'}
						editorType={'dxSelectBox'}
						cssClass="uppercase"
						editorOptions={{
							dataSource: logisticRouteStatusDataSource,
							searchEnabled: true,
							valueExpr: 'id',
							displayExpr: 'name',
							searchModeOption: 'contains',
							searchTimeoutOption: 200,
							minSearchLengthOption: 2,
							showDataBeforeSearchOption: false,
						}}
						label={{ text: 'Status' }}
					/>
					<SimpleItem
						colSpan={1}
						dataField={'startDate'}
						editorType={'dxDateBox'}
						editorOptions={{
							type: 'datetime',
							displayFormat: 'dd/MM/yyyy HH:mm',
						}}
						label={{ text: 'Data Inicial' }}
					/>
					<SimpleItem
						colSpan={1}
						dataField={'endDate'}
						editorType={'dxDateBox'}
						editorOptions={{
							type: 'datetime',
							displayFormat: 'dd/MM/yyyy HH:mm',
						}}
						label={{ text: 'Data Final' }}
					/>
					<SimpleItem
						colSpan={5}
						dataField={'logisticRouteId'}
						editorType={'dxSelectBox'}
						cssClass="uppercase"
						editorOptions={{
							dataSource: logisticRouteDataSource,
							searchEnabled: true,
							valueExpr: 'id',
							displayExpr: function (item) {
								if (item)
									return (
										item.sender +
										' | ' +
										item.recipient +
										' | ' +
										item.shippingCompany +
										' | ' +
										item.ship +
										' | ' +
										item.product
									);
								else return '';
							},
							searchModeOption: 'contains',
							searchTimeoutOption: 200,
							minSearchLengthOption: 2,
							showDataBeforeSearchOption: false,
						}}
						label={{ text: 'Rota de Carregamento' }}
					/>
					<SimpleItem
						colSpan={3}
						dataField={'vehicleId'}
						editorType={'dxSelectBox'}
						cssClass="uppercase"
						editorOptions={{
							dataSource: vehicleDataSource,
							searchEnabled: true,
							valueExpr: 'id',
							displayExpr: 'document.number',
							searchModeOption: 'contains',
							searchTimeoutOption: 200,
							minSearchLengthOption: 2,
							showDataBeforeSearchOption: false,
						}}
						label={{ text: 'Veículo' }}
					/>
					<SimpleItem
						colSpan={2}
						dataField={'driverId'}
						editorType={'dxSelectBox'}
						cssClass="uppercase"
						editorOptions={{
							dataSource: driverDataSource,
							searchEnabled: true,
							valueExpr: 'id',
							displayExpr: 'name',
							searchModeOption: 'contains',
							searchTimeoutOption: 200,
							minSearchLengthOption: 2,
							showDataBeforeSearchOption: false,
						}}
						label={{ text: 'Motorista' }}
					/>
					<SimpleItem
						colSpan={3}
						dataField={'term'}
						cssClass="uppercase"
						label={{ text: 'Buscar por', showColon: false }}
					/>
					<SimpleItem
						colSpan={1}
						dataField={'orderField'}
						editorType={'dxSelectBox'}
						cssClass="uppercase"
						editorOptions={{
							dataSource: this.fieldOrder,
							searchEnabled: true,
							valueExpr: 'id',
							displayExpr: 'name',
							searchModeOption: 'contains',
							searchTimeoutOption: 200,
							minSearchLengthOption: 2,
							showDataBeforeSearchOption: false,
						}}
						label={{ text: 'Ordenar' }}
					/>
					<SimpleItem>
						<div className="btn-group btn-group-justified" role="group" aria-label="Basic example">
							<a href="javascript:return" className="btn btn-info" onClick={this.onClickSearch}>
								<i className="fa fa-search" />
								&nbsp; Buscar
							</a>
							<a href="javascript:return" className="btn btn-success" onClick={this.onClickExport}>
								<i className="fa fa-file-excel" />
								&nbsp; Exportar
							</a>
							{/* <button type="button" onClick={this.onClickSearch} class="btn btn-info">
								<i className="fa fa-search" />
								&nbsp; Buscar
							</button>
							<button type="button" onClick={this.onClickExport} class="btn btn-success">
								<i className="fa fa-file-excel" />
								&nbsp; Exportar
							</button> */}
						</div>

						{/* <button onClick={this.onClickSearch} type="button" className="btn btn-info btn-block">
							<i className="fa fa-search" />
							&nbsp; Buscar
						</button> */}
					</SimpleItem>
				</GroupItem>
			</Form>
		);
	}

	renderPopupChangeSatusLoadTrasnporting() {
		return (
			<Popup
				visible={this.state.popupChangeStatusTransportLogisticRoute.show}
				onHiding={() => {
					this.setState({ ...this.state, popupChangeStatusTransportLogisticRoute: { show: false } });
				}}
				resizeEnabled={true}
				dragEnabled={true}
				closeOnOutsideClick={false}
				showTitle={true}
				height={'640px'}
				title={this.state.popupChangeStatusTransportLogisticRoute.actionText + ' da Ordem'}
			>
				<Form
					formData={this.state.changeStatusTransportLogisticRoute}
					ref={this.form}
					showColonAfterLabel={false}
					labelLocation={'left'}
				>
					<GroupItem colCount={4} caption={'Informações da Nota de Carregamento'}>
						<SimpleItem
							colSpan={1}
							dataField={'transportLogisticRoute.id'}
							cssClass="uppercase"
							label={{ text: 'Nº' }}
							editorOptions={{ disabled: true }}
						/>
						<SimpleItem
							colSpan={1}
							dataField={'transportLogisticRoute.transportedOn'}
							editorType={'dxDateBox'}
							editorOptions={{
								type: 'datetime',
								disabled: true,
								displayFormat: 'dd/MM/yyyy HH:mm',
							}}
							label={{ text: 'Data/Hora' }}
						/>
						<SimpleItem
							dataField={'transportLogisticRoute.status'}
							colSpan={2}
							editorOptions={{ disabled: true }}
							label={{ text: 'Status Atual' }}
						/>
						<SimpleItem
							dataField={'transportLogisticRoute.sender'}
							colSpan={2}
							editorOptions={{ disabled: true }}
							label={{ text: 'Remetente' }}
						/>
						<SimpleItem
							dataField={'transportLogisticRoute.recipient'}
							colSpan={2}
							editorOptions={{ disabled: true }}
							label={{ text: 'Destinatário' }}
						/>
						<SimpleItem
							dataField={'transportLogisticRoute.shippingCompany'}
							colSpan={4}
							editorOptions={{ disabled: true }}
							label={{ text: 'Transportadora' }}
						/>
						<SimpleItem
							dataField={'transportLogisticRoute.driver'}
							colSpan={2}
							editorOptions={{ disabled: true }}
							label={{ text: 'Motorista' }}
						/>
						<SimpleItem
							dataField={'transportLogisticRoute.vehicle'}
							colSpan={2}
							editorOptions={{ disabled: true }}
							label={{ text: 'Veículo' }}
						/>
					</GroupItem>
					<GroupItem
						colCount={4}
						caption={'Informações para ' + this.state.popupChangeStatusTransportLogisticRoute.actionText}
					>
						<SimpleItem
							dataField={'registerDate'}
							editorType={'dxDateBox'}
							editorOptions={{
								type: 'datetime',
								displayFormat: 'dd/MM/yyyy HH:mm',
							}}
							colSpan={
								this.state.changeStatusTransportLogisticRoute.statusId> 3 
									? 4
									: 1
							}
							label={{ text: 'Data e Hora' }}
						/>
						<SimpleItem
							dataField={'totalWeight'}
							colSpan={1}
							editorOptions={{
								disabled: this.state.changeStatusTransportLogisticRoute.statusId === 3 ? false : true,
								min: 0,
								max: 9000000000000000,
								format: '#,##0 kg',
								onValueChanged:(e) => {
									this.calculateWeight();
								}
								
							}}
							visible={
								this.state.changeStatusTransportLogisticRoute.statusId=== 3 
									? true
									: false
							}
							editorType={'dxNumberBox'}
							cssClass="uppercase"
							name={"txtTotalWeight"}
							label={{ text: 'Peso Total (kg)' }}
						/>
						<SimpleItem
							dataField={'vehicleWeight'}
							colSpan={1}
							editorOptions={{
								disabled: this.state.changeStatusTransportLogisticRoute.statusId === 3? false : true,
								min: 0,
								max: 9000000000000000,
								format: '#,##0 kg',
								
								onValueChanged:(e) => {
									this.calculateWeight();
								}
								
							}}
							visible={
								this.state.changeStatusTransportLogisticRoute.statusId=== 3 
									? true
									: false
							}
							name={"txtVehicleWeight"}
							editorType={'dxNumberBox'}
							cssClass="uppercase"
							label={{ text: 'Tara (kg)' }}
						/>
						<SimpleItem
							dataField={'weight'}
							colSpan={1}
							editorOptions={{
								disabled: true,
								min: 0,
								max: 9000000000000000,
								format: '#,##0 kg',
							}}

							visible={
								this.state.changeStatusTransportLogisticRoute.statusId=== 3 
									? true
									: false
							}
							editorType={'dxNumberBox'}
							cssClass="uppercase"
							label={{ text: 'Peso Final (kg)' }}
						/>
						{/* <SimpleItem
							colSpan={
								this.state.changeStatusTransportLogisticRoute.statusId >= 4 ||
								this.state.changeStatusTransportLogisticRoute.statusId === 2
									? 3
									: 2
							}
						/> */}
						<SimpleItem
							colSpan={1}
							dataField={'fiscalDocumentNumber'}
							cssClass="uppercase"
							visible={
								this.state.changeStatusTransportLogisticRoute.statusId >= 3 &&
									this.state.changeStatusTransportLogisticRoute.statusId !== 4
									? true
									: false
							}
							label={{ text: 'Nº da Nota', showColon: false }}
						/>

						<SimpleItem
							colSpan={2}
							visible={
								this.state.changeStatusTransportLogisticRoute.statusId >= 3 &&
									this.state.changeStatusTransportLogisticRoute.statusId !== 4
									? true
									: false
							}
							dataField={'fiscalDocumentBarCode'}
							label={{ text: 'Código de Barras', showColon: false }}
						/>
						<SimpleItem
							dataField={'fiscalDocumentDate'}
							editorType={'dxDateBox'}
							visible={
								this.state.changeStatusTransportLogisticRoute.statusId >= 3 &&
									this.state.changeStatusTransportLogisticRoute.statusId !== 4
									? true
									: false
							}
							editorOptions={{
								type: 'datetime',
								displayFormat: 'dd/MM/yyyy HH:mm',
							}}
							label={{ text: 'Data da Emissão' }}
						/>
						<SimpleItem
							colSpan={4}
							dataField={'description'}
							editorOptions={{ inputAttr: { rows: 4 } }}
							editorType={'dxTextArea'}
							label={{ text: 'Mais Informações', visible: true, location: 'top' }}
						/>
						<SimpleItem colSpan={4}>
							<div className="pull-right block">
								<button
									type="button"
									className="btn btn-success btn-block"
									onClick={this.onClickSaveChangeStatus}
								>
									<i className="fa fa-check" />
									&nbsp; Salvar
								</button>
							</div>
						</SimpleItem>
					</GroupItem>
				</Form>
			</Popup>
		);
	}
	renderForm() {
		return (
			<React.Fragment>
				<Form
					formData={this.transportLogisticRoute}
					ref={this.form}
					showColonAfterLabel={false}
					labelLocation={'left'}
				>
					<GroupItem colCount={6} caption={'Informações Básicas'}>
						<SimpleItem
							colSpan={2}
							dataField={'id'}
							cssClass="uppercase"
							label={{ text: 'Nº' }}
							editorOptions={{ disabled: true }}
						/>
						<SimpleItem
							colSpan={1}
							dataField={'transportedOn'}
							editorType={'dxDateBox'}
							editorOptions={{
								disabled: this.state.transportLogisticRoute.id != null ? true : false,
								type: 'datetime',
								displayFormat: 'dd/MM/yyyy HH:mm',
							}}
							label={{ text: 'Data/Hora' }}
						/>
						<SimpleItem
							dataField={'status'}
							colSpan={3}
							editorOptions={{ disabled: true }}
							label={{ text: 'Status' }}
						/>

						<SimpleItem
							colSpan={6}
							dataField={'logisticRouteId'}
							editorType={'dxSelectBox'}
							cssClass="uppercase"
							editorOptions={{
								dataSource: logisticRouteDataSource,
								searchEnabled: true,
								valueExpr: 'id',
								disabled: (this.state.transportLogisticRoute.id === null ||
									this.state.transportLogisticRoute.statusId >= 3)
									? false
									: true,
								displayExpr: function (item) {
									if (item)
										return (
											item.sender +
											' | ' +
											item.recipient +
											' | ' +
											item.shippingCompany +
											' | ' +
											item.ship +
											' | ' +
											item.product
										);
									else return '';
								},
								searchModeOption: 'contains',
								searchTimeoutOption: 200,
								minSearchLengthOption: 2,
								showDataBeforeSearchOption: false,
							}}
							label={{ text: 'Rota de Carregamento' }}
						/>
						<SimpleItem
							colSpan={3}
							dataField={'driverId'}
							editorType={'dxSelectBox'}
							cssClass="uppercase"
							editorOptions={{
								dataSource: driverDataSource,
								searchEnabled: true,
								valueExpr: 'id',
								displayExpr: 'name',
								searchModeOption: 'contains',
								searchTimeoutOption: 200,
								minSearchLengthOption: 2,
								showDataBeforeSearchOption: false,
							}}
							label={{ text: 'Motorista' }}
						/>
						<SimpleItem
							colSpan={3}
							dataField={'vehicleId'}
							editorType={'dxSelectBox'}
							cssClass="uppercase"
							editorOptions={{
								dataSource: vehicleDataSource,
								searchEnabled: true,
								valueExpr: 'id',
								displayExpr: 'document.number',
								searchModeOption: 'contains',
								searchTimeoutOption: 200,
								minSearchLengthOption: 2,
								showDataBeforeSearchOption: false,
							}}
							label={{ text: 'Caminhão' }}
						/>
						<GroupItem colCount={3} colSpan={4} >
							<SimpleItem
								dataField={'totalWeight'}
								colSpan={1}
								editorOptions={{
									disabled: this.state.transportLogisticRoute.statusId >= 3 ? false : true,
									min: 0,
									max: 9000000000000000,
									format: '#,##0 kg',
								}}
								editorType={'dxNumberBox'}
								cssClass="uppercase"
								label={{ text: 'Peso Total (kg)' }}
							/>
							<SimpleItem
								dataField={'vehicleWeight'}
								colSpan={1}
								editorOptions={{
									disabled: this.state.transportLogisticRoute.statusId >= 3 ? false : true,
									min: 0,
									max: 9000000000000000,
									format: '#,##0 kg',
								}}
								editorType={'dxNumberBox'}
								cssClass="uppercase"
								label={{ text: 'Tara (kg)' }}
							/>
							<SimpleItem
								dataField={'weight'}
								colSpan={1}
								editorOptions={{
									disabled: true,
									min: 0,
									max: 9000000000000000,
									format: '#,##0 kg',
								}}
								editorType={'dxNumberBox'}
								cssClass="uppercase"
								label={{ text: 'Peso Final (kg)' }}
							/>
						</GroupItem>
					</GroupItem>

					<GroupItem
						colCount={2}
						caption={'Informações da Nota Fiscal'}
						visible={this.state.transportLogisticRoute.statusId >= 3 ? true : false}
					>
						<SimpleItem
							dataField={'fiscalDocumentNumber'}
							cssClass="uppercase"
							label={{ text: 'Nº da Nota', showColon: false }}
						/>
						<SimpleItem
							dataField={'fiscalDocumentDate'}
							editorType={'dxDateBox'}
							editorOptions={{
								type: 'datetime',
								disabled: this.state.transportLogisticRoute.statusId >= 5 ? true : false,
								displayFormat: 'dd/MM/yyyy HH:mm',
							}}
							label={{ text: 'Data da Emissão' }}
						/>
						<SimpleItem
							colSpan={2}
							dataField={'fiscalDocumentBarCode'}
							label={{ text: 'Código de Barras', showColon: false }}
						/>
					</GroupItem>
					<TabbedItem
						tabPanelOptions={{
							onTitleClick: () => {
								this.historicDataGrid.current.instance.option(
									'dataSource',
									this.transportLogisticRoute.historic
								);
							},
						}}
					>
						<Tab title="Mais Informações">
							<SimpleItem
								dataField={'moreInformation'}
								editorOptions={{ inputAttr: { rows: 4 } }}
								editorType={'dxTextArea'}
								label={{ text: 'Observação', visible: false }}
							/>
						</Tab>
						<Tab title="Histórico" onTitleClick={this.onMoreInformationActiveTabChange}>
							<DataGrid
								repaintChangesOnly={true}
								ref={this.historicDataGrid}
								height={150}
								defaultColumns={[
									{
										dataField: 'onCreated',
										caption: 'Alterado em',
										dataType: 'date',
										format: 'dd/MM/yyyy HH:mm:ss',
									},
									{ dataField: 'createdBy', caption: 'Alterado por' },
									{
										dataField: 'registerDate',
										dataType: 'date',
										caption: 'Data do Registro',
										format: 'dd/MM/yyyy HH:mm',
									},

									{ dataField: 'status', caption: 'Status' },
									{ dataField: 'description', caption: 'Descrição' },
								]}
								showBorders={true}
							/>
						</Tab>
					</TabbedItem>
					<GroupItem>
						<div className="pull-right">
							<button type="button" className="btn btn-right-space btn-primary" onClick={this.onClickNew}>
								<i className="fa fa-plus" />
								&nbsp; Novo
							</button>
							<button type="button" className="btn btn-success" onClick={this.onClickSave}>
								<i className="fa fa-check" />
								&nbsp; Salvar
							</button>
						</div>
					</GroupItem>
				</Form>
			</React.Fragment>
		);
	}
	render(props) {
		masterProps.outTabs = this.renderPopupChangeSatusLoadTrasnporting();
		masterProps.form = this.renderForm();
		masterProps.dataGrid = this.renderGrid();
		masterProps.filter = this.renderFilter();
		return <CrudForm {...masterProps} ref={this.crudForm} />;
	}
}
